// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"PageWrapper_titleWrapper_iez55","title":"PageWrapper_title_1vy2n"};